import React from 'react';

import { ContentCardPadding, ContentCardVariant } from '../types';

import { StyledCardFooter } from './index.styles';

interface ContentCardFooterProps extends React.ComponentProps<typeof StyledCardFooter> {
  actions?: React.ReactNode;
  showDivider: boolean;
  padding: ContentCardPadding;
  variant: ContentCardVariant;
}

const ContentCardFooter = ({
  showDivider = false,
  actions,
  padding,
  variant,
  ...rest
}: ContentCardFooterProps) => (
  <StyledCardFooter $showDivider={showDivider} $padding={padding} $variant={variant} {...rest}>
    {actions}
  </StyledCardFooter>
);

export default ContentCardFooter;
